module.exports = __webpack_public_path__ + "static/sport/bgi-gorm.acbe75a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/bgi-gorm.png
// module id = Hqku
// module chunks = 0